import * as types from './types';
import actions from './actions';
import {
  extend,
  each,
  set
} from 'lodash';

const state = {
  //结算学院列表
  listOfClearingSchools: {
    state: '',
    list: [],
    total: 0,
  },
  toolBookStatementCollegeBookStatementDetail:{
    state : '',
    advance_payment : null,
  }
};

const getters = {
  getListOfClearingSchools: (state)=>state.listOfClearingSchools,//结算学院列表
  getToolBookStatementCollegeBookStatementDetail : (state) => state.toolBookStatementCollegeBookStatementDetail,//学院结算详情

};

const mutations = {
  //获取院系列表
  [types.ACTION_GET_LIST_OF_CLEARING_SCHOOL_PORT]({listOfClearingSchools}, result){
    extend(listOfClearingSchools, result);
  },
  [types.ACTION_TOOL_NOOK_STATEMENT_COLLEGE_BOOK_STATEMENT]({toolBookStatementCollegeBookStatementDetail}, result){
    extend(toolBookStatementCollegeBookStatementDetail, result);
  }


};


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Admin/modules/listOfClearingSchools/index.js